import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/lib/i18n";
import { blogContent } from "./content";

export function RefoundSection() {
  const { language } = useLanguage();
  const c = blogContent[language].refound;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 pb-12">
      <h2 className="font-['Source_Serif_4'] text-[1.75rem] sm:text-[2rem] leading-tight font-semibold text-foreground mt-4 mb-5">
        {c.title}
      </h2>

      <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 mb-6">
        {c.intro}
      </p>

      <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 mb-10">
        <strong className="text-foreground font-semibold">{c.conceptLabel}</strong>
        {c.conceptText}
      </p>

      <div className="space-y-10">
        {c.features.map((feature, idx) => {
          const isPrimary = "primary" in feature && feature.primary === true;
          return (
            <article
              key={idx}
              className={cn(
                isPrimary &&
                  "relative border-l-2 border-primary bg-primary/[0.04] rounded-r-lg pl-5 sm:pl-6 pr-4 py-5 -ml-1"
              )}
            >
              {isPrimary ? (
                <div className="inline-flex items-center gap-1.5 mb-3 rounded-full bg-primary/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-primary font-['Funnel_Display']">
                  <ShieldCheck className="h-3 w-3" />
                  {c.crucialBadge}
                </div>
              ) : null}
              <h3 className="font-['Source_Serif_4'] text-xl sm:text-2xl font-semibold text-foreground leading-snug mb-4">
                <span className="text-primary mr-2">{idx + 1}.</span>
                {feature.title}
              </h3>

              {feature.paragraphs.map((para, j) => (
                <p key={j} className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 mb-4">
                  {para}
                </p>
              ))}

              {"bullets" in feature && feature.bullets ? (
                <ul className="space-y-3 mt-4">
                  {feature.bullets.map((bullet, j) => (
                    <li
                      key={j}
                      className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 pl-6 relative"
                    >
                      <span className="absolute left-0 top-[0.7em] h-1.5 w-1.5 rounded-full bg-primary" />
                      {bullet}
                    </li>
                  ))}
                </ul>
              ) : null}
            </article>
          );
        })}
      </div>
    </section>
  );
}
